// Auth pages
import Authenticate from './authenticate'
import AuthenticateApp from './authenticate-app'
import Login from './login'
import Register from './register'
import Lock from './lock'
import CreateMasterPassword from './create-master-password'
import SetupPasswordless from './setup-pwl'
import Setup2FA from './setup-2fa'

export default {
  Authenticate,
  AuthenticateApp,
  Login,
  Register,
  Lock,
  CreateMasterPassword,
  SetupPasswordless,
  Setup2FA
}